import React from 'react';
import {Link} from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {LogoutIcon} from "../../../../helpers/Icons";

function LogoutAppBar() {

  return(
    <Tabs value='logout' variant="scrollable">
      <Tab label="Logout" icon={<LogoutIcon />} value="logout" component={Link} to="/logout" />
    </Tabs>
  )
}
export default LogoutAppBar
